import type { QueryDef } from '@/hooks/useDefinedQuery'

/**
 * QueryDef for a quantities cache that is *seeded* by another hook
 * (`useUserQuantities`) and must never actually fetch. The stub `queryFn`
 * resolves `{}`; `staleTime: Infinity` keeps it from re-running and clobbering
 * the seeded data. Shared so both the list and collection factories can't drift.
 */
export function seededQuery(queryKey: QueryDef<Record<number, number>>['queryKey']): QueryDef<Record<number, number>> {
  return {
    queryKey,
    queryFn: () => Promise.resolve({}),
    staleTime: Infinity,
    auth: 'required',
  }
}
